__turbopack_context__.v({
  "button": "jet-book1440px-module-scss-module__7Fj9EW__button",
  "buttonSimple": "jet-book1440px-module-scss-module__7Fj9EW__buttonSimple",
  "comboboxParent": "jet-book1440px-module-scss-module__7Fj9EW__comboboxParent",
  "errorMessage": "jet-book1440px-module-scss-module__7Fj9EW__errorMessage",
  "form": "jet-book1440px-module-scss-module__7Fj9EW__form",
  "inputWrapper": "jet-book1440px-module-scss-module__7Fj9EW__inputWrapper",
  "item": "jet-book1440px-module-scss-module__7Fj9EW__item",
  "item1": "jet-book1440px-module-scss-module__7Fj9EW__item1",
  "jetbook1440px": "jet-book1440px-module-scss-module__7Fj9EW__jetbook1440px",
  "leftcol": "jet-book1440px-module-scss-module__7Fj9EW__leftcol",
  "search": "jet-book1440px-module-scss-module__7Fj9EW__search",
  "tabactive": "jet-book1440px-module-scss-module__7Fj9EW__tabactive",
  "tabdefault": "jet-book1440px-module-scss-module__7Fj9EW__tabdefault",
  "tabs": "jet-book1440px-module-scss-module__7Fj9EW__tabs",
  "text": "jet-book1440px-module-scss-module__7Fj9EW__text",
  "textFormWrapper": "jet-book1440px-module-scss-module__7Fj9EW__textFormWrapper",
  "title": "jet-book1440px-module-scss-module__7Fj9EW__title",
  "title1": "jet-book1440px-module-scss-module__7Fj9EW__title1",
  "whetherYoureA": "jet-book1440px-module-scss-module__7Fj9EW__whetherYoureA",
});
